<script lang="ts">
  import ProgressBar from '../../ui/ProgressBar/ProgressBar.svelte'
  import ProgressBarBackgroundBar from '../../ui/ProgressBar/compounds/ProgressBarBackgroundBar.svelte'
  import ProgressBarCompletionBar from '../../ui/ProgressBar/compounds/ProgressBarCompletionBar.svelte'
  import ProgressBarHoverBar from '../../ui/ProgressBar/compounds/ProgressBarHoverBar.svelte'
  import ProgressBarCursor from '../../ui/ProgressBar/compounds/ProgressBarCursor.svelte'
  import ProgressBarCompletionTimeMobile from '../../ui/ProgressBar/compounds/ProgressBarCompletionTimeMobile.svelte'
  import ProgressBarCompletionTime from '../../ui/ProgressBar/compounds/ProgressBarCompletionTime.svelte'
  import ProgressBarHoverTime from '../../ui/ProgressBar/compounds/ProgressBarHoverTime.svelte'
  import videoStore from '../../../stores/video.svelte'
  import chapters from '../../../stores/chapters.svelte'

  let duration = $derived(videoStore.state.duration)

  let currentTime = $derived(videoStore.state.currentTime)

  let progressBarBackgroundParts = $derived(
    chapters.state.cues?.length
      ? chapters.state.cues.map((chapter, index) => {
          const chapterEnd =
            chapters.state.cues.length === index + 1 ? duration : chapter.end
          return {
            left: (chapter.start / duration) * 100,
            width: ((chapterEnd - chapter.start) / duration) * 100,
            start: chapter.start,
            end: chapterEnd,
            text: chapter.text,
          }
        })
      : [{ start: 0, width: 100, left: 0, end: duration, text: '' }],
  )

  let progressBarProgressionParts = $derived(
    chapters.state.cues?.length
      ? chapters.state.cues
          .filter((cue) => cue.start <= currentTime)
          .map((chapter) => {
            return {
              left: (chapter.start / duration) * 100,
              width:
                ((Math.min(chapter.end, currentTime) - chapter.start) /
                  duration) *
                100,
            }
          })
      : [
          {
            width: (currentTime / duration) * 100,
            left: 0,
          },
        ],
  )
</script>

<ProgressBar {duration}>
  <ProgressBarBackgroundBar backgroundParts={progressBarBackgroundParts} />
  <ProgressBarHoverBar {duration} {currentTime} />
  <ProgressBarCompletionBar progressionParts={progressBarProgressionParts} />
  {#if !videoStore.state.isMobileLayout}
    <ProgressBarCursor {duration} {currentTime} />
  {/if}
  {#if (videoStore.showControls() || !videoStore.state.isPlaying) && videoStore.state.hasPlaybackStarted}
    {#if videoStore.state.isMobileLayout}
      <ProgressBarCompletionTimeMobile {currentTime} endTime={duration} />
    {:else}
      <ProgressBarCompletionTime {currentTime} endTime={duration} />
    {/if}
    {#if progressBarBackgroundParts.length <= 1 && !videoStore.state.isMobileLayout}
      <ProgressBarHoverTime {duration} />
    {/if}
  {/if}
</ProgressBar>
